import { SupportedLanguage, supportedLanguages } from "@/lib/shared";

/** Build a path under `[locale]`, e.g. `/following` + `ar` → `/ar/following` */
export function localizedPath(locale: SupportedLanguage, path: string): string {
  const trimmed = path.trim();
  const [pathnamePart, ...searchParts] = trimmed.split("?");
  const search = searchParts.length > 0 ? `?${searchParts.join("?")}` : "";

  const pathname = pathnamePart.startsWith("/")
    ? pathnamePart
    : `/${pathnamePart}`;

  const base =
    pathname === "/" ? `/${locale}` : `/${locale}${pathname}`;

  return `${base}${search}`;
}

/**
 * مسار صفحة البروفايل العام — يطابق `hr-web-main`:
 * `src/app/[locale]/(main)/profiles/[profileId]/page.tsx` → `/{locale}/profiles/{id}`.
 * في Next كان `<Link href="/profiles/...">` تحت مجلد `[locale]`؛ في الـ SPA يجب بادئة اللغة صراحةً.
 */
export function publicProfileHref(
  locale: SupportedLanguage,
  profileId: string,
): string {
  return localizedPath(locale, `/profiles/${profileId}`);
}

/**
 * After login/register, navigate here. Preserves paths that already include `/${locale}`.
 */
export function postAuthRedirectHref(
  locale: SupportedLanguage,
  redirectPath: string | null | undefined,
): string {
  if (!redirectPath || redirectPath === "/") {
    return localizedPath(locale, "/");
  }
  const t = redirectPath.trim();
  if (t === `/${locale}` || t.startsWith(`/${locale}/`)) {
    return t;
  }
  return localizedPath(locale, t);
}

/** For overlay / route comparisons — avoids `/settings` vs `/settings/` mismatch. */
export function normalizePathTrailingSlashes(pathname: string): string {
  const p = (pathname || "").trim();
  if (p === "" || p === "/") return "/";
  const noTrailing = p.replace(/\/+$/, "");
  return noTrailing === "" ? "/" : noTrailing;
}

/** مسارات تبويبات الإعدادات — لا تُفعَّل عليها overlay التحميل الذي يعطّل النقر */
export function isSettingsHubPath(pathNoLocale: string): boolean {
  const p = pathNoLocale || "/";
  return p === "/settings" || p.startsWith("/settings/");
}

/** Strip `/ar` or `/en` prefix for active-state checks */
export function pathWithoutLocale(pathname: string): string {
  const segments = pathname.split("/").filter(Boolean);
  const first = segments[0];
  if (first && supportedLanguages.includes(first as SupportedLanguage)) {
    const rest = segments.slice(1).join("/");
    return rest ? `/${rest}` : "/";
  }
  return pathname || "/";
}
